import { Command } from "cmdk";
import type { ComponentProps } from "react";

import { cn } from "../../utils";
import { useComboboxContext } from "./context";

// oxlint-disable-next-line typescript/no-empty-object-type
export interface InlineEditSelectListProps extends ComponentProps<typeof Command.List> {}

const List = ({ ref, className, children, ...props }: InlineEditSelectListProps) => {
  const { listRef, multiple } = useComboboxContext();

  return (
    <Command.List
      aria-multiselectable={multiple || undefined}
      {...props}
      // Registered as the context's listRef so Root's cursor effects can scroll this container.
      ref={node => {
        listRef.current = node;
        if (typeof ref === "function") {
          ref(node);
        } else if (ref) {
          ref.current = node;
        }
      }}
      className={cn(
        "w-full overflow-y-auto lg:max-h-[400px] [&>div]:px-2 [&>div]:py-1 [&>div:empty]:p-0",
        "lg:[#combobox-content:has(#combobox-search)_&>div]:pt-1 lg:[&>div]:p-2",
        className
      )}
    >
      {children}
    </Command.List>
  );
};

export default List;
